import { useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { Checkbox } from '@/components/ui/checkbox'
import { ASMTreeNode, RawAssemblyTree } from '@/state'
import { useCADPageStore } from '@/state'
import { useTreeNodeRangeSelector } from '@/pages/CADPage/components/AssemblyTree/hooks/useTreeNodeRangeSelector'

export const TreeNodeCheckbox = ({
  tree,
  node,
  id,
  isVisible = false,
}: {
  tree: RawAssemblyTree
  node: ASMTreeNode
  id?: string
  isVisible?: boolean
}) => {
  const setState = useCADPageStore(useShallow((state) => state.setState))
  const selectedParts = useCADPageStore((state) => state.selectedParts)
  const selectTreeNodeRange = useTreeNodeRangeSelector()

  const isSelected = useMemo(
    () => selectedParts.includes(node.uuid),
    [node.uuid, selectedParts],
  )

  const shouldShowCheckbox = isVisible || isSelected

  if (!shouldShowCheckbox) {
    return <div className="w-4 h-4"></div>
  }

  return (
    <Checkbox
      id={id}
      className="w-4 shrink-0"
      checked={isSelected}
      onMouseDown={(e) => {
        e.stopPropagation()
        const shiftKey = e.shiftKey

        if (shiftKey) {
          selectTreeNodeRange(tree, node)
          return
        }

        if (isSelected) {
          setState({
            selectedParts: selectedParts.filter(
              (partUUID) => partUUID !== node.uuid,
            ),
          })
        } else {
          setState({
            selectedParts: [...selectedParts, node.uuid],
          })
        }
      }}
    />
  )
}
